export const slugsSelector = (state) => state.slugs;
